import { PropertyConfig } from '../../utils/FhirResourceDisplayPropertyConfig/propertyConfig';
import { TableSortState } from '@lifeomic/chroma-react/components/TableModule';

export type SortOrder = 'asc' | 'desc' | null;

export const defaultSortState: TableSortState = {
  sortDirection: null,
  sortKey: null,
};

export default function getDefaultColumnSort(
  configuredColumns: PropertyConfig[] = [],
): TableSortState {
  const defaultSortColumnIndex = configuredColumns
    .filter(Boolean)
    .findIndex(column => column.defaultSort);

  if (defaultSortColumnIndex !== -1) {
    return {
      sortDirection: 'desc',
      sortKey: defaultSortColumnIndex,
    };
  }

  const firstSortableColumnIndex = configuredColumns
    .filter(Boolean)
    .findIndex(config => !config.disableSort);

  if (firstSortableColumnIndex !== -1) {
    return {
      sortDirection: 'asc',
      sortKey: firstSortableColumnIndex,
    };
  }

  return defaultSortState;
}
